<nb-card class="dialog-card">
  <nb-card-header>
    {{
      isEdit
        ? ("pages.dozent.faqs.editEntry" | translate)
        : ("pages.dozent.faqs.newEntry" | translate)
    }}
  </nb-card-header>
  <nb-card-body>
    <div class="form-field">
      <label>{{ "pages.dozent.faqs.question" | translate }} *</label>
      <input
        nbInput
        fullWidth
        [(ngModel)]="model.question"
        alAnchor="faq.question"
        [placeholder]="'pages.dozent.faqs.questionPlaceholder' | translate"
      />
    </div>

    <div class="form-field">
      <label>{{ "pages.dozent.faqs.answer" | translate }} *</label>
      <textarea
        nbInput
        fullWidth
        rows="4"
        [(ngModel)]="model.answer"
        alAnchor="faq.answer"
        [placeholder]="'pages.dozent.faqs.answerPlaceholder' | translate"
      ></textarea>
    </div>

    <div class="form-row-inline">
      <div class="form-field">
        <label>{{ "pages.dozent.faqs.category" | translate }}</label>
        <nb-select
          [selected]="showCustomCategory ? '__custom__' : model.category"
          (selectedChange)="onCategoryChange($event)"
          size="small"
        >
          <nb-option *ngFor="let cat of allCategories" [value]="cat">
            {{ getCategoryLabel(cat) }}
          </nb-option>
        </nb-select>
        <input
          *ngIf="showCustomCategory"
          nbInput
          fullWidth
          [(ngModel)]="customCategory"
          [placeholder]="'pages.dozent.faqs.customCategoryPlaceholder' | translate"
          class="custom-category-input"
        />
      </div>

      <div class="form-field" alAnchor="faq.dozent">
        <label>{{ "pages.dozent.faqs.assignDozent" | translate }}</label>
        <nb-select
          multiple
          [(selected)]="model.dozent_bot_ids"
          [placeholder]="'pages.dozent.faqs.selectDozent' | translate"
          size="small"
          [disabled]="!tutors || tutors.length === 0"
        >
          <nb-option *ngFor="let dozent of tutors" [value]="dozent.id">
            {{ dozent.visual_name || dozent.name }}
          </nb-option>
        </nb-select>
        <small
          class="hint hint--warning"
          *ngIf="!tutors || tutors.length === 0"
        >
          {{ "pages.dozent.faqs.noDozentBotsHint" | translate }}
        </small>
        <small
          class="hint"
          *ngIf="
            tutors &&
            tutors.length > 0 &&
            (model.dozent_bot_ids?.length || 0) === 0
          "
        >
          {{ "pages.dozent.faqs.assignDozentHint" | translate }}
        </small>
      </div>
    </div>

    <div class="form-field" *ngIf="courses.length > 0">
      <label>{{ "pages.dozent.faqs.assignCourse" | translate }}</label>
      <nb-select
        [(selected)]="model.course_id"
        [placeholder]="'pages.dozent.faqs.selectCourse' | translate"
        size="small"
      >
        <nb-option [value]="undefined">—</nb-option>
        <nb-option *ngFor="let course of courses" [value]="course.id">
          {{ course.name || course.course_name }}
        </nb-option>
      </nb-select>
    </div>

    <div class="form-field">
      <label>{{ "pages.dozent.faqs.version" | translate }}</label>
      <input
        nbInput
        fullWidth
        [(ngModel)]="model.version"
        placeholder="z.B. 1.0, 1.1, 2.0"
        style="max-width: 120px;"
      />
    </div>

    <div class="toggle-row">
      <nb-toggle [(checked)]="model.is_active">
        {{
          model.is_active
            ? ("pages.dozent.faqs.active" | translate)
            : ("pages.dozent.faqs.inactive" | translate)
        }}
      </nb-toggle>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost size="small" (click)="close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      size="small"
      (click)="submit()"
      [disabled]="!model.question || !model.answer || !(model.dozent_bot_ids?.length)"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
